var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"login"}},[_c('div',{staticClass:"login-container"},[(_vm.authLink)?_c('AuthForm'):_c('LoginForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }